import React from "react";
import './DownArrowIcon.css'

function DownArrowIcon() {
    return (
        <svg viewBox="0 0 12 6" xmlns="http://www.w3.org/2000/svg" className="App-downArrowIcon">
            <path d="m5.93831,6l0.56867,-0.45682l5.34462,-4.35069l-1.13528,-1.19249l-4.77587,3.88794l-4.77805,-3.88794l-1.13519,1.19248l5.34458,4.3507l0.56866,0.45682l-0.00214,0z"/>
        </svg>
    );
}

export default DownArrowIcon;